import axios from 'axios';

const getFindables = async (query) => {
    let response = axios.get(`${process.env.PUBLIC_URL}/json/findables.json`);
    return response;
}

const getFindable = async (query) => {
    const findables = await getFindables();
    const data = findables.data;

    let key, value = null;
    if( query ) {
        key   = Object.keys(query)[0];
        value = Object.values(query)[0];
    }

    const promise = new Promise((resolve) => {
        let result = null;

        if( key && value ) {
            result = data.find((d) => d[key] === value);
        }

        resolve({data: result});
    })

    return promise;
}

window.getFindable = getFindable;
export { getFindables, getFindable };
